import styles from '../../assets/styles/Login/Login.module.scss';
import { MimaButton, MimaInput } from '../../components';
import { Formik } from 'formik';
import React from 'react';

const ResetPasswordForm = ({ validationSchema, onSubmit, loading }) => {
	return (
		<Formik
			initialValues={{
				password: '',
				confirmPassword: '',
			}}
			validationSchema={validationSchema()}
			onSubmit={onSubmit}
		>
			{({
				handleChange,
				handleBlur,
				handleSubmit,
				values,
				errors,
				touched,
			}) => (
				<div>
					<MimaInput
						type="text"
						labelTitle="New Password"
						placeholder="Enter your new password"
						name="password"
						value={values.password}
						onChange={handleChange}
						onBlur={handleBlur}
						mr={2}
						error={errors.password}
						touched={touched.password}
						passwordIcon
					/>
					<MimaInput
						type="text"
						labelTitle="Confirm Password"
						placeholder="Confirm your new password"
						name="confirmPassword"
						value={values.confirmPassword}
						onChange={handleChange}
						onBlur={handleBlur}
						mr={2}
						error={errors.confirmPassword}
						touched={touched.confirmPassword}
						passwordIcon
					/>

					<MimaButton
						title="Continue"
						onClick={handleSubmit}
						type="submit"
						loading={loading}
						variant="form"
						mt={2}
					/>
				</div>
			)}
		</Formik>
	);
};

export default ResetPasswordForm;
